/** Mulberry32: a replay-local generator, never shared with presentation. */
export class Random {
 constructor(public state:number) {this.state>>>=0;}
 next():number {let t=this.state=(this.state+0x6D2B79F5)>>>0;t=Math.imul(t^(t>>>15),t|1);t^=t+Math.imul(t^(t>>>7),t|61);return ((t^(t>>>14))>>>0)/4294967296;}
 int(min:number,max:number){return min+Math.floor(this.next()*(max-min+1));}
 shuffle<T>(a:readonly T[]):T[]{const b=[...a];for(let i=b.length-1;i>0;i--){const j=this.int(0,i);[b[i],b[j]]=[b[j],b[i]];}return b;}
}
export function freshSeed():number{return crypto.getRandomValues(new Uint32Array(1))[0];}
export function parseSeed(value:string):number {let h=2166136261;for(const c of value)h=Math.imul(h^c.charCodeAt(0),16777619);return /^\d+$/.test(value)?Number(value)>>>0:h>>>0;}
